/* ScheduleStatusComponent.js */

"use strict";
const _ = require("lodash");
const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl.DefaultColumnComponent;
const Renderer = require("./ScheduleStatusRenderer");

class ScheduleStatusComponent extends DefaultColumnComponent {
    constructor(entity) {
        super(entity);
        this._entity = entity;
        this._value = entity.status;
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /* *****************************************
    /* START PUBLIC API METHODS
    /* ***************************************** */
    setValue(newVal) {
        if (!_.isUndefined(newVal)) {
            this.setScheduleStatus(newVal);
        }
    }

    getValue() {
        return this.getScheduleStatus();
    }

    setScheduleStatus(newVal) {
        this._value = newVal;
        this.emit("ScheduleStatus", newVal);
        return this;
    }

    getScheduleStatus() {
        return this._value;
    }

    getErrorMsg() {
        return this._entity.errorMsg;
    }

    /* *****************************************
    /* END PUBLIC API METHODS
    /* ***************************************** */
}

module.exports = ScheduleStatusComponent;
